import { call, put, takeLatest } from 'redux-saga/effects'
import { NetworkContractActionTypes, NetworkContractActionCreators } from '../reducers/NetworkContractRedux'
import NetworkContractAPI from '../services/api/entities/networkContract'

function* checkConsentType() {
  try {
    // Call the API to check consent type for add_new_child permission
    const result = yield call(NetworkContractAPI.checkConsentType)

    if (result.response && result.response.data && result.response.data.consentType) {
      const consentType = result.response.data.consentType;

      let documentUrl = null

      if (consentType === 'ACCEPTANCE') {
        // Get document URL for NETWORK_CONTRACT using the correct endpoint
        try {
          const pdfResult = yield call(NetworkContractAPI.getDocumentUrl, 'network-contract')
          documentUrl = pdfResult && pdfResult.response && pdfResult.response.data.url
        } catch (docError) {
          console.warn('Could not fetch document URL:', docError)
          // Continue with consent type check even if document URL fails
        }
      }

      yield put(NetworkContractActionCreators.checkConsentTypeSuccess({
        consentType,
        documentUrl,
      }))
    } else {
      yield put(NetworkContractActionCreators.checkConsentTypeFailure({
        message: 'Invalid response from consent type API'
      }))
    }
  } catch (error) {
    console.error('Error checking consent type:', error)
    yield put(NetworkContractActionCreators.checkConsentTypeFailure({
      message: error.message || 'Error al verificar el tipo de consentimiento',
      error: error
    }))
  }
}

function* acceptNetworkContract() {
  try {
    const response = yield call(NetworkContractAPI.acceptNetworkContract, 'network-contract')
    yield put(NetworkContractActionCreators.acceptNetworkContractSuccess(response.response.data))
  } catch (error) {
    console.error('Error accepting network contract:', error)
    yield put(NetworkContractActionCreators.acceptNetworkContractFailure({
      message: error.message || 'Error al aceptar el contrato de red',
      error
    }))
  }
}

// Check if user has add_new_child permission (following FiscalInfoSagas pattern)
function* checkAddNewChildPermission() {
  try {
    const response = yield call(NetworkContractAPI.checkAddNewChildPermissions)
    
    if (response.status === 200) {
      // User has permission, hide modal
      yield put(NetworkContractActionCreators.setShowNetworkModal(false))
    } else {
      // User lacks permission, should show modal and check consent type
      yield put(NetworkContractActionCreators.setShowNetworkModal(true))
      // Now check consent type since user needs to see the modal
      yield call(checkConsentType)
    }
  } catch (error) {
    console.error('Error checking user permissions:', error)
    // On error, assume user needs to see the modal (lacks permission)
    yield put(NetworkContractActionCreators.setShowNetworkModal(true))
    // Also check consent type in case of error
    yield call(checkConsentType)
  }
}

// Export individual saga functions for use in main sagas index
export { checkConsentType, acceptNetworkContract, checkAddNewChildPermission }

export default function* networkContractSaga() {
  yield takeLatest(NetworkContractActionTypes.CHECK_CONSENT_TYPE, checkConsentType)
  yield takeLatest(NetworkContractActionTypes.ACCEPT_NETWORK_CONTRACT, acceptNetworkContract)
  yield takeLatest(NetworkContractActionTypes.CHECK_ADD_NEW_CHILD_PERMISSION, checkAddNewChildPermission)
}
